<template>
  <!-- 车辆管理 -->
  <div  class="treeBigBox app-container">
     <!--树形结构-->
    <div class="boxLeft">
      <div class="title">
        <div class="xian"></div>
        <div>车辆管理</div>
      </div>
      <div class="treeBox">
        <el-tree :data="orgTreeData"
          node-key="id"
          ref="orgTree"
          :props="defaultProps"
          :default-expand-all="true"
          :expand-on-click-node="false"
          :current-node-key="currentData.orgId"
          :highlight-current="true"
           :render-content="renderContent"
          @node-click="handleNodeClick">
        </el-tree>
      </div>
    </div>
  <div class="right">
    <div class="formBox margbot" ref="searchBox">
        <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
          <div class=" formItemBox formItemWid">
                <!-- <el-form-item label="主车/挂车：" >
                  <el-select v-model="searchFrom.trailerFlag"   placeholder="请选择" >
                      <el-option label="主车" value="0" ></el-option>
                      <el-option label="挂车" value="1" ></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="挂车号牌:" prop="vhcNo">
                  <el-input  placeholder="" v-model="searchFrom.vhcNo"></el-input>
                </el-form-item>
                <!-- <el-form-item label="绑定挂车号:" prop="trailerNo">
                  <el-input  placeholder="" v-model="searchFrom.trailerNo"></el-input>
                </el-form-item> -->
                <el-form-item label="车辆类型:" prop="vhcTypeId" >
                  <el-select placeholder="请选择" v-model="searchFrom.vhcTypeId">
                    <el-option
                      v-for="item in vehicleT"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="状态" >
                  <el-select v-model="searchFrom.blacklistStatus"   placeholder="请选择" >
                      <el-option label="正常" value="0" ></el-option>
                      <el-option label="已拉黑" value="1" ></el-option>
                    </el-select>
                </el-form-item>

              <el-form-item label="使用性质:" prop="purposeId">
                  <el-select placeholder="请选择" v-model="searchFrom.purposeId">
                    <el-option
                      v-for="item in clyt"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="能源类型:" prop="energyId">
                  <el-select placeholder="请选择" v-model="searchFrom.energyId">
                    <el-option
                      v-for="item in NYtype"
                      :key="item.id"
                      :label="item.energyName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
              </el-form-item>

              <el-form-item label="发动机号:" prop="vhcEngineNo">
                  <el-input  placeholder="" v-model="searchFrom.vhcEngineNo"></el-input>
                </el-form-item>

                <el-form-item label="创建时间:" prop="createTime">
                      <el-date-picker
                        v-model="searchFrom.createTime"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      ></el-date-picker>
                    </el-form-item>
        </div>
        <div class="searchBtnBox">
            <el-button type="primary"  v-if="btnFlg[0]" @click="searchFn">查询</el-button>
            <el-button type="primary" v-if="btnFlg[1]" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary"  v-if="btnFlg[2]&&zhuhuCode==currentData.tenantCode"  @click="addVeicle">新增</el-button>
            <el-button type="primary"  v-if="btnFlg[3]&&zhuhuCode==currentData.tenantCode" @click="delVeicle">删除</el-button>
            <el-button type="primary" size="mini" @click="exportFn" v-if="btnFlg[9]" :disabled="isDisable">导出</el-button>
        </div>
        </el-form>
      </div>
      <!--  表格 -->
      <div class="table" :style="{height:h}">
        <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' class="tableComent"
        @row-click="handleRowClick" height="100%" style="width: 100%" center border :cell-style="getCellStyle">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" btnCode="00IM0B0004"  v-if="btnFlg[4]&&zhuhuCode==currentData.tenantCode" @click="modifyVeicle(scope.row)">修改</el-button>
                <el-button type="text" size="mini" btnCode="00IP001B006"  v-if="btnFlg[6]&&scope.row.blacklistStatus== '0'&&zhuhuCode==currentData.tenantCode" @click="laheiFn(scope.row)">拉黑</el-button>
                <el-button type="text" size="mini" btnCode="00IP001B006"  v-if="btnFlg[7]&&scope.row.blacklistStatus== '1'&&zhuhuCode==currentData.tenantCode" @click="jiesuoFn(scope.row)">解锁</el-button>
                <el-button type="text" size="mini" @click="diaoboFn(scope.row)" v-if="btnFlg[8]&&zhuhuCode==currentData.tenantCode" >调拨</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="vhcNo"  width="80" :formatter="emptyFn" label="挂车号">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini"  @click="lookFn(scope.row)">{{scope.row.vhcNo}}</el-button>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="trailerNo"  width="100" :formatter="emptyFn" label="绑定挂车号">
              <template slot-scope="scope">
                <div>
                  <el-button type="text" size="mini"  @click="lookFn(scope.row,1)">{{scope.row.trailerNo}}</el-button>
                </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="blacklistStatus" width="80" :show-overflow-tooltip="true" :formatter="emptyFn" label="拉黑状态">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.blacklistStatus == '0'">正常</div>
                <div  v-if="scope.row.blacklistStatus == '1'">已拉黑</div>
              </div>
            </template>
          </el-table-column>
           <el-table-column prop="teamOrgName" width="100" :show-overflow-tooltip="true" :formatter="emptyFn" label="所属队"></el-table-column>
          <!-- <el-table-column prop="operationOrgName" width="100" :show-overflow-tooltip="true" :formatter="emptyFn" label="所属组"></el-table-column> -->
          <el-table-column prop="vhcTypeName"  width="120" :show-overflow-tooltip="true" :formatter="emptyFn" label="车辆类型"></el-table-column>
          <el-table-column prop="noColourName" width="80"  :show-overflow-tooltip="true" :formatter="emptyFn" label="车牌颜色"></el-table-column>
            <!-- <el-table-column prop="energyName" width="100"  :show-overflow-tooltip="true" :formatter="emptyFn" label="能源类型"></el-table-column> -->
           <el-table-column prop="drivingExpiringDate" width="110" :formatter="dateFormat"  label="行驶证到期日"></el-table-column>
             <el-table-column prop="transportDateTo" width="140" :formatter="dateFormat"  label="运输资格证到期日"></el-table-column>
            <el-table-column prop="vhcQuality" width="100"  :show-overflow-tooltip="true" :formatter="emptyFn" label="总质量(吨)"></el-table-column>
            <el-table-column prop="weight"  min-width="100"  :show-overflow-tooltip="true" :formatter="emptyFn" label="载重(吨)"></el-table-column>
            <el-table-column prop="vhcLongName"  min-width="150" :show-overflow-tooltip="true" :formatter="emptyFn" label="外廓尺寸"></el-table-column>
            <!-- <el-table-column prop="standardsName"  min-width="80" :show-overflow-tooltip="true" :formatter="emptyFn" label="排放标准"></el-table-column> -->
             <el-table-column prop="blacklistReason" min-width="110" :show-overflow-tooltip="true" :formatter="emptyFn" label="拉黑原因"></el-table-column>
          <el-table-column prop="createUserName"  min-width="100" :show-overflow-tooltip="true" :formatter="emptyFn" label="创建人"></el-table-column>
          <el-table-column prop="createTime" min-width="170" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div>
        <el-pagination background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchFrom.pageNo"
          :page-sizes="[25,50,100]"
          :page-size="searchFrom.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

      <!-- 新增修改 -->
      <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="closeDialog('addFrom')" width="1200px" center>
        <span>
          <el-form :inline="true" :model="addFrom" ref="addFrom" :rules="rules" class="demo-form-inline yanzheng jiaoyan" label-width="120px" size="mini" v-if="dialogVisible">
           <!-- <el-form-item label="所属分级：" label-width="100px" >
               <el-cascader v-if="!isAdd" v-model="addFrom.operationOrgId" style="width:400px" ref="zuzhicascader" @change="zuzhiChange" :options="BMlist"  :props="{ expandTrigger:'hover',  label:'name',value:'id',emitPath:false}"  ></el-cascader>
               <span v-else>{{zuzhiquanming}}</span>
            </el-form-item> -->
            <!-- <el-form-item label="主车/挂车：" label-width="140px" >
                <el-radio-group v-model="addFrom.trailerFlag" v-if="isAdd">
                  <el-radio  label="0" value="0">主车</el-radio>
                  <el-radio  label="1" value="1">挂车</el-radio>
                </el-radio-group>
                <span v-else>{{['主车','挂车'][addFrom.trailerFlag]}}</span>
            </el-form-item> -->
            <div class="addressBox" style="margin-top:20px">
              <h4 class="title">
                <span><i class="fa fa-picture-o iconFont" aria-hidden="true"></i>基本信息</span>
              </h4>
            </div>
            <div style="display: flex;">
              <div class="box" v-if="newImgFlag">
                <div class="imgBox" style="margin-bottom:15px">
                  <uploadImg :img='img' @remove ='handleRemove' @change ='imgPreview'></uploadImg>
                  <h6>行驶证(印徽页)</h6>
                </div>
                <div class="imgBox" style="margin-bottom:15px">
                  <uploadImg :img='img1' @remove ='handleRemove1' @change ='imgPreview1'></uploadImg>
                  <h6>行驶证(条码页)</h6>
                </div>
                <div class="imgBox" style="margin-bottom:15px">
                  <uploadImg :img='img2' @remove ='handleRemove2' @change ='imgPreview2'></uploadImg>
                  <h6>行驶证(年检页)</h6>
                </div>
                <div class="imgBox">
                  <uploadImg :img='img3' @remove ='handleRemove3' @change ='imgPreview3'></uploadImg>
                  <h6>道路运输证(正页)</h6>
                </div>
              </div>
              <div class="inpBoxA">
                <div class="borderBox" style="margin-bottom:25px">
                  <el-form-item label="挂车号:" prop="vhcNo">
                    <el-input placeholder="" :class="{ 'disabled': !isAdd }" :readonly="!isAdd" v-model.trim="addFrom.vhcNo" maxlength="20"></el-input>
                  </el-form-item>
                  <el-form-item label="能源类型:" class="is-required"  prop="energyName" v-if="addFrom.trailerFlag=='0'">
                    <el-select placeholder="请选择" value-key="id" v-model="addFrom.energyName" >
                      <el-option
                        v-for="item in NYtype"
                        :key="item.id"
                        :label="item.energyName"
                        :value="item.energyName"
                        v-if="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="排放标准:"  prop="standardsName" v-if="addFrom.trailerFlag=='0'">
                    <el-select placeholder="请选择" value-key="id"  v-model="addFrom.standardsName">
                      <el-option
                        v-for="item in pfbz"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                        v-if="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <br>
                  <el-form-item label="绑定挂车号:" v-if="addFrom.trailerFlag=='0'" >
                    <el-select placeholder="请选择" value-key="id"  v-model="addFrom.trailerNo" clearable  >
                      <el-option
                        v-for="item in gcList"
                        :key="item.id"
                        :label="item.vhcNo"
                        :value="item.vhcNo"
                        v-if="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="车牌颜色:" class="is-required"  prop="noColour">
                    <el-select placeholder="请选择" value-key="id" v-model="addFrom.noColour" >
                      <el-option
                        v-for="item in clys"
                        :key="item.id"
                        :label="item.colourName"
                        :value="item"
                        v-if="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="车辆所有人:"  prop="vehicleTenantName">
                    <el-input placeholder="" maxlength="50" v-model="addFrom.vehicleTenantName"></el-input>
                  </el-form-item>
                  <br>
                  <el-form-item label="品牌:" >
                    <el-input placeholder="" maxlength="17" v-model="addFrom.brandModel"></el-input>
                  </el-form-item>
                  <el-form-item label="型号:" >
                    <el-input placeholder="" maxlength="17" v-model="addFrom.vehicleModel"></el-input>
                  </el-form-item>
                  <el-form-item label="车辆类型:" class="is-required"  prop="vhcTypeName">
                    <el-select placeholder="请选择" value-key="id" v-model="addFrom.vhcTypeName" @change="vhcTypeChange">
                      <el-option
                        v-for="item in vehicleT"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                        v-if="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="注册日期:" prop="registerDate">
                    <el-date-picker
                      v-model="addFrom.registerDate"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期时间"
                      :picker-options="pickerOptions"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="发证日期:" prop="issueDate">
                    <el-date-picker
                      v-model="addFrom.issueDate"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="date"
                        placeholder="选择日期时间"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="发证机关:"  prop="issueAuthority">
                    <el-input  placeholder="" maxlength="17"  v-model="addFrom.issueAuthority"></el-input>
                  </el-form-item>
                  <el-form-item label="检验有效期:" prop="drivingExpiringDate" >
                    <el-date-picker
                      v-model="addFrom.drivingExpiringDate"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期时间"
                      :picker-options="pickerOptionsB"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="使用性质:"  prop="purposeName">
                    <el-select placeholder="请选择" value-key="id"  filterable allow-create
                    default-first-option v-model="addFrom.purposeName" >
                      <el-option
                        v-for="item in clyt"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                        v-if="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="车辆识别代号:" prop="vhcVinNo">
                    <el-input  placeholder=""  maxlength="18" v-model="addFrom.vhcVinNo"></el-input>
                  </el-form-item>
                  <el-form-item label="发动机号:"  prop="vhcEngineNo" v-if="addFrom.trailerFlag=='0'">
                    <el-input  placeholder=""  maxlength="17"  v-model="addFrom.vhcEngineNo"></el-input>
                  </el-form-item>
                  <el-form-item label="外廓尺寸/米:"  class="wkccBox">
                    长 <el-input  placeholder=""  maxlength="18" style="width:80px"  v-model="addFrom.vhcLongNameChang" v-number-input.float="3"></el-input>
                    宽 <el-input  placeholder=""  maxlength="18" style="width:80px"  v-model="addFrom.vhcLongNamekuan" v-number-input.float="3"></el-input>
                    高<el-input  placeholder=""  maxlength="17"  style="width:80px"  v-model="addFrom.vhcLongNameGao"></el-input>
                  </el-form-item>
                  <el-form-item label="总质量(吨):" class="zlBox"  label-width="110px" >
                    <el-input  placeholder="" v-model="addFrom.vhcQuality"   v-number-input.float="3" maxlength="11"></el-input>
                  </el-form-item>
                  <el-form-item label="载重(吨):"  class="zlBox"  label-width="100px">
                    <el-input  placeholder=""  v-model="addFrom.weight"  v-number-input.float="3" maxlength="11"></el-input>
                  </el-form-item>
                  <el-form-item label="购车款:" prop="purchasePrice">
                    <el-input placeholder="" v-model="addFrom.purchasePrice" v-number-input.float="2" maxlength="15"></el-input>
                  </el-form-item>
                  <el-form-item label="残值类型:" prop="residualType">
                    <el-radio-group v-model="addFrom.residualType" @change="residualChange">
                      <el-radio label="1">残值率</el-radio>
                      <el-radio label="2">残值金额</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="残值率(%):" prop="residualRate" v-if="addFrom.residualType == '1'">
                    <el-input placeholder="" v-model="addFrom.residualRate" v-number-input.float="3" maxlength="11"></el-input>
                  </el-form-item>
                  <el-form-item label="残值金额(元):" prop="residualAmount" v-if="addFrom.residualType == '2'">
                    <el-input placeholder="" v-model="addFrom.residualAmount" v-number-input.float="2" maxlength="11"></el-input>
                  </el-form-item>
                  <el-form-item label="折旧开始日期:" prop="depreciationStartDate">
                    <el-date-picker
                      v-model="addFrom.depreciationStartDate"
                      type="month"
                      format="yyyy-MM"
                      value-format="yyyy-MM"
                      :clearable="false"
                      placeholder="请选择">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="折旧结束日期:" prop="depreciationEndDate">
                    <el-date-picker
                      v-model="addFrom.depreciationEndDate"
                      type="month"
                      format="yyyy-MM"
                      value-format="yyyy-MM"
                      :clearable="false"
                      placeholder="请选择">
                    </el-date-picker>
                  </el-form-item>
                </div>
                <div class="borderBox" style="padding: 20px 10px 10px 15px;">
                  <el-form-item label="道路运输证号:"  prop="transportNo" >
                    <el-input  placeholder=""  maxlength="17"  v-model="addFrom.transportNo"></el-input>
                  </el-form-item>
                  <el-form-item label="经营许可证号:"  prop="businessLicenseNo" >
                    <el-input  placeholder=""  maxlength="17"  v-model="addFrom.businessLicenseNo"></el-input>
                  </el-form-item>
                  <el-form-item label="运输证有效期:" prop="transportDateTo" label-width="140">
                    <el-date-picker
                      v-model="addFrom.transportDateTo"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期时间"
                      :picker-options="pickerOptionsB"
                    ></el-date-picker>
                  </el-form-item>
                </div>
              </div>
            </div>
            <!-- <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>保险信息</span>
                <el-button type="primary" size="mini" @click="addGoodFn({})" style="margin-left:8px">新增</el-button>
              </h4>
            </div>
            <div style="padding-bottom:16px"   >
              <el-table :data="addFrom.insuranceList" class="bxBox"    bordersize="mini"  style="width: 100%" max-height="500px"  center border v-if="dialogVisible">
                <el-table-column type="index"  label="序号" width="60"></el-table-column>
                <el-table-column label="操作"  width="100">
                  <template slot-scope="scope">
                    <div>
                      <el-button type="text" size="mini" @click="addGoodFn(scope.row)">新增</el-button>
                      <el-button type="text" size="mini" @click="delGoodFn(scope.$index)">删除</el-button>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="保险类型" min-width="120">
                  <template slot="header" >
                    <div><span class="red">*</span>保险类型</div>
                  </template>
                  <template slot-scope="scope">
                    <div>
                      <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.insuranceProject'" :key="scope.$index" :rules="rules.insuranceProject" class="table_error">
                        <el-select  v-model="addFrom.insuranceList[scope.$index].insuranceProject" filterable    >
                          <el-option  label="交强险" value="交强险" ></el-option>
                          <el-option  label="三者险" value="三者险" ></el-option>
                          <el-option  label="车损险" value="车损险" ></el-option>
                          <el-option  label="商业险" value="商业险" ></el-option>
                          <el-option  label="盗抢险" value="盗抢险" ></el-option>
                          <el-option  label="不计免赔" value="不计免赔" ></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="保费/年"  min-width="80">
                  <template slot="header" >
                    <div><span class="red">*</span>保费/年</div>
                  </template>
                  <template slot-scope="scope">
                    <div>
                      <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.insuranceCosts'" :key="scope.$index" :rules="rules.insuranceCosts"  class="table_error">
                        <el-input placeholder="" maxlength="10" v-number-input.float="2"
                          v-model.trim="addFrom.insuranceList[scope.$index].insuranceCosts" ></el-input>
                      </el-form-item>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="保单起止日期"  min-width="140">
                  <template slot="header" >
                    <div><span class="red">*</span>保单起止日期</div>
                  </template>
                  <template slot-scope="scope">
                    <div>
                      <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.insuranceDate'" :key="scope.$index" :rules="rules.insuranceDate" class="table_error">
                        <el-date-picker  style="width: 200px"  v-model="addFrom.insuranceList[scope.$index].insuranceDate"  format="yyyy-MM-dd"   value-format="yyyy-MM-dd"
                          type="daterange"  range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期" @change="bdrqChange($event,scope.$index)"  ></el-date-picker>
                      </el-form-item>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="备注"  min-width="100">
                  <template slot-scope="scope">
                    <div>
                      <el-form-item label="" :prop="'insuranceList.' +scope.$index+ '.remark'" :key="scope.$index"  class="table_error">
                        <el-input placeholder="" maxlength="10"
                          v-model.trim="addFrom.insuranceList[scope.$index].remark" ></el-input>
                      </el-form-item>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
             <div class="addressBox"  style="margin-bottom:20px">
              <h4 class="title">
                <span><i class="fa fa-picture-o iconFont" aria-hidden="true"></i>租赁费用信息</span>
              </h4>
              <el-form-item label=" 租赁费用/月:"  prop="rentalCosts" label-width="180">
                <el-input  placeholder=""  maxlength="17"  v-number-input.float="2" v-model="addFrom.rentalCosts"></el-input>
              </el-form-item>
              <el-form-item label="租赁起止日期:" prop="zlqzrq" label-width="140">
                <el-date-picker
                  v-model="addFrom.zlqzrq"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div> -->
            <div class="addressBox" v-if="addFrom.trailerFlag=='0'">
              <h4 class="title">
                <span><i class="fa fa-picture-o iconFont" aria-hidden="true"></i>环保清单</span>
              </h4>
            </div>
            <div class="box"  v-if="addFrom.trailerFlag=='0'&&newImgFlag">
              <div class="imgBox">
                  <uploadImg :img='img4'  @remove ='handleRemove4'  @change ='imgPreview4'></uploadImg>
                  <h6>环保清单</h6>
              </div>
            </div>

          </el-form>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 查看 -->
      <el-dialog title="车辆详情" :close-on-click-modal="false" class="detailBox" :close-on-press-escape="false" :visible.sync="lookImgVisible" @close="closeDialogB" width="1200px" center>
        <span>
          <el-form :inline="true" :model="addFrom" ref="addFrom" :rules="rules" class="demo-form-inline" label-width="110px" size="mini">
          <el-form-item label="所属分级：" label-width="100px" >
              <span  style="width:300px">{{addFrom.teamOrgName}}/{{addFrom.operationOrgName}}</span>
          </el-form-item>
          <!-- <el-form-item label="主车/挂车：" >
            <span>{{['主车','挂车'][addFrom.trailerFlag]}}</span>
          </el-form-item> -->
          <div class="addressBox" style="margin-top:16px">
            <h4 class="title">
              <span><i class="fa fa-picture-o iconFont" aria-hidden="true"></i>基本信息</span>
            </h4>
          </div>
          <div style="display: flex;">
            <div class="box" >
              <div class="imgBox" style="margin-bottom:15px">
                <el-image
                  :src="addFrom.vhcLicense1Url"
                  :preview-src-list="[addFrom.vhcLicense1Url,addFrom.vhcLicense2Url,addFrom.vhcLicense3Url,addFrom.transportPhotoUrl,addFrom.environmentalProtectionFileUrl]">
                </el-image>
                <h6>行驶证(印徽页)</h6>
              </div>
              <div class="imgBox" style="margin-bottom:15px">
                <el-image
                  :src="addFrom.vhcLicense2Url"
                  :preview-src-list="[addFrom.vhcLicense2Url,addFrom.vhcLicense3Url,addFrom.transportPhotoUrl,addFrom.environmentalProtectionFileUrl,addFrom.vhcLicense1Url]">
                </el-image>
                <h6>行驶证(印徽页)</h6>
              </div>
              <div class="imgBox" style="margin-bottom:15px">
                <el-image
                  :src="addFrom.vhcLicense3Url"
                  :preview-src-list="[addFrom.vhcLicense3Url,addFrom.transportPhotoUrl,addFrom.environmentalProtectionFileUrl,addFrom.vhcLicense1Url,addFrom.vhcLicense2Url]">
                </el-image>
                <h6>行驶证(印徽页)</h6>
              </div>
              <div class="imgBox" style="margin-bottom:15px">
                <el-image
                  :src="addFrom.transportPhotoUrl"
                  :preview-src-list="[addFrom.transportPhotoUrl,addFrom.environmentalProtectionFileUrl,addFrom.vhcLicense1Url,addFrom.vhcLicense2Url,addFrom.vhcLicense3Url]">
                </el-image>
                <h6>道路运输证(正页)</h6>
              </div>
              </div>
              <div class="inpBoxA">
                <div class="borderBox" style="margin-bottom:15px;padding: 10px;">
                   <el-form-item label="挂车号:" prop="vhcNo">
                      <span>{{addFrom.vhcNo}}</span>
                    </el-form-item>
                    <el-form-item label="能源类型:" class="is-required"  prop="energy" v-if="addFrom.trailerFlag=='0'">
                       <span>{{addFrom.energyName}}</span>
                    </el-form-item>
                    <el-form-item label="排放标准:"  prop="standardsName" v-if="addFrom.trailerFlag=='0'">
                        <span>{{addFrom.standardsName}}</span>
                    </el-form-item>
                    <br>
                    <el-form-item label="绑定挂车号:" v-if="addFrom.trailerFlag=='0'" >
                        <span>{{addFrom.standardsName}}</span>
                    </el-form-item>
                    <el-form-item label="车牌颜色:" class="is-required"  prop="noColour">
                        <span>{{addFrom.noColourName}}</span>
                    </el-form-item>
                    <el-form-item label="车牌所有人:" class="is-required"  prop="noColour" >
                        <span style="width:400px">{{addFrom.vehicleTenantName}}</span>
                    </el-form-item>
                    <br>
                     <el-form-item label="品牌:" >
                      <span>{{addFrom.brandModel}}</span>
                    </el-form-item>
                     <el-form-item label="型号:" >
                      <span>{{addFrom.vehicleModel}}</span>
                    </el-form-item>
                    <el-form-item label="车辆类型:" class="is-required"  prop="vhcTypeName">
                      <span>{{addFrom.vhcTypeName}}</span>
                  </el-form-item>
                  <el-form-item label="注册日期:" prop="registerDate">
                  <span>{{addFrom.registerDate|dateFormat1}}</span>
                  </el-form-item>
                  <el-form-item label="发证日期:" prop="issueDate">
                    <span>{{addFrom.issueDate|dateFormat1}}</span>
                  </el-form-item>
                  <el-form-item label="发证机关:"  prop="issueAuthority">
                     <span style="width:420px">{{addFrom.issueAuthority}}</span>
                  </el-form-item>
                  <el-form-item label="检验有效期:" prop="drivingExpiringDate" >
                    <span>{{addFrom.drivingExpiringDate|dateFormat1}}</span>
                  </el-form-item>
                  <el-form-item label="使用性质:"  prop="purposeName">
                      <span>{{addFrom.purposeName}}</span>
                  </el-form-item>
                  <el-form-item label="车辆识别代号:" prop="vhcVinNo">
                   <span>{{addFrom.vhcVinNo}}</span>
                  </el-form-item>
                  <el-form-item label="发动机号:"  prop="vhcEngineNo" v-if="addFrom.trailerFlag=='0'">
                    <span>{{addFrom.vhcEngineNo}}</span>
                  </el-form-item>
                  <el-form-item label="外廓尺寸/米:"  >
                    <span>{{addFrom.vhcLongName}}</span>
                  </el-form-item>
                  <el-form-item label="总质量(吨):"  >
                    <span>{{addFrom.vhcQuality}}</span>
                  </el-form-item>
                  <el-form-item label="载重(吨):" >
                    <span>{{addFrom.weight}}</span>
                  </el-form-item>
                  <el-form-item label="购车款:">
                    <span>{{addFrom.purchasePrice}}</span>
                  </el-form-item>
                  <el-form-item label="残值类型:">
                    <span>{{addFrom.residualType == '1' ? '残值率' : '残值金额' }}</span>
                  </el-form-item>
                  <el-form-item label="残值率(%):" v-if="addFrom.residualType == '1'">
                    <span>{{addFrom.residualRate}}</span>
                  </el-form-item>
                  <el-form-item label="残值值金额(元):" v-if="addFrom.residualType == '2'">
                    <span>{{addFrom.residualAmount}}</span>
                  </el-form-item>
                  <el-form-item label="折旧开始日期:">
                    <span>{{addFrom.depreciationStartDate}}</span>
                  </el-form-item>
                  <el-form-item label="折旧结束日期:">
                    <span>{{addFrom.depreciationEndDate}}</span>
                  </el-form-item>
                </div>
                <div class="borderBox" style="padding: 20px 10px 5px 15px;">
                  <el-form-item label="道路运输证号:" prop="transportNo" >
                     <span>{{addFrom.transportNo}}</span>
                  </el-form-item>
                  <el-form-item label="经营许可证号:"  prop="businessLicenseNo" >
                    <span>{{addFrom.businessLicenseNo}}</span>
                  </el-form-item>
                  <el-form-item label="运输证有效期:" prop="transportDateTo">
                    <span>{{addFrom.transportDateTo|dateFormat1}}</span>
                  </el-form-item>
                </div>
              </div>
            </div>
             <!-- <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>保险信息</span>
              </h4>
            </div>
            <div style="padding-bottom:16px"   >
              <el-table :data="addFrom.cVehicleInsuranceList" class="bxBox"    bordersize="mini"  style="width: 100%" max-height="500px"  center border >
                <el-table-column type="index"  label="序号" width="60"></el-table-column>
                <el-table-column label="保险公司" min-width="120" property="insuranceCompany" ></el-table-column>
               <el-table-column label="保费/年" min-width="120" property="insuranceCosts" >
                 <template slot-scope="scope">
                    <div>
                      <span>{{scope.row.insuranceCosts/100}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="保单起止日期"  min-width="140">
                  <template slot-scope="scope">
                    <div>
                      {{scope.row.insuranceDateFrom|dateFormat1}}至{{scope.row.insuranceDateTo|dateFormat1}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="备注" min-width="120" property="remark" ></el-table-column>
              </el-table>
            </div>
            <div class="addressBox"  style="margin-bottom:20px">
              <h4 class="title">
                <span><i class="fa fa-picture-o iconFont" aria-hidden="true"></i>租赁费用信息</span>
              </h4>
               <el-form-item label="  租赁费用/月:"  prop="rentalCosts">
                  <span>{{addFrom.rentalCosts/100}}</span>
                </el-form-item>
                <el-form-item label="租赁起止日期:" prop="zlqzrq" label-width="140">
                  {{addFrom.rentalDateFrom|dateFormat1}}至{{addFrom.rentalDateTo|dateFormat1}}
                </el-form-item>
            </div> -->

            <div class="addressBox" v-if="addFrom.trailerFlag=='0'">
              <h4 class="title">
                <span><i class="fa fa-picture-o iconFont" aria-hidden="true"></i>环保清单</span>
              </h4>
              <div class="box" >
                <div class="imgBox">
                    <el-image
                          :src="addFrom.environmentalProtectionFileUrl"
                          :preview-src-list="[addFrom.environmentalProtectionFileUrl,addFrom.vhcLicense1Url,addFrom.vhcLicense2Url,addFrom.vhcLicense3Url,addFrom.transportPhotoUrl]">
                        </el-image>
                </div>
              </div>
            </div>
          </el-form>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="lookImgVisible = false">取 消</el-button>
        </span>
      </el-dialog>
       <!-- 调拨 -->
        <el-dialog title="调拨" :close-on-click-modal="false" :close-on-press-escape="false"
          :visible.sync="dbMark" width="600px" center>
          <el-form :inline="true" :rules="rules" :model="dbFrom" ref="dbFrom" class="demo-form-inline jiaoyan" label-width="160px" size="mini">
             <el-form-item label="调拨到：" label-width="100px" prop="suoshuOrgId">
               <el-cascader v-model="dbFrom.suoshuOrgId" style="width:400px" ref="zuzhicascader" @change="zuzhiChange" :options="BMlist"
               :props="{ expandTrigger:'hover',  label:'name',value:'id',emitPath:false, checkStrictly: true}"  ></el-cascader>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dbMark = false">取 消</el-button>
            <el-button type="primary" @click="dbSave()">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="拉黑" @close="closeDialogC" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="LHMark" width="600px" center>
        <el-form :inline="true" :rules="rules" :model="LHFrom" ref="LHFrom" class="demo-form-inline jiaoyan" label-width="160px" size="mini">
          <el-form-item label="拉黑原因:" prop="blacklistReason">
            <el-input placeholder="" maxlength="500" v-model="LHFrom.blacklistReason" size="mini" style="width: 260px;"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="LHMark = false">取 消</el-button>
          <el-button type="primary" @click="LHSave()">确 定</el-button>
        </span>
      </el-dialog>
  </div>
</div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { compressImage } from '@/utils/compressImage'
import uploadImg from '@/components/uploadImg.vue'
import { emptyFn, dateTimeFormat, dateFormat, dateFormat1 } from '@/utils/util'
import { cVIlists, cVIadds, cVIupdates, cVIdeletes, cVTlist, cVPlist, organizationTree, ocrIdentification, addBlackList, VdelBlackList,
  cVElist, getCVehicleInfo, cVhcEnergyTypeList, cVhcNoColourList, cVehicleInfoDiaobos, cVehicleInfoDetail, tOverdueSetList } from '@/api/vgs-driver2.0'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  components: {
    uploadImg
  },
  data () {
    return {
      defaultProps: {
        label: 'name',
        children: 'children'
      },
      // 组织机构树
      orgTreeData: [],
      currentData: {},
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      h: '500px',
      total: 0,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      addFrom: {
        vhcClassify1: [],
        vhcPhoto1: '',
        vhcPhoto2: '',
        guaKaoUrl: ''
      },
      importDialog: false,
      isAdd: false,
      title: '添加',
      vehicleL: [],
      vehicleT: [],
      clyt: [],
      pfbz: [],
      vhcType: {},
      vhcL: {},
      ids: [],
      rules: {
        vhcLongNameChang: [
          { required: true, message: '请输入长', trigger: 'blur' }
        ],
        vhcLongNamekuan: [
          { required: true, message: '请输入宽', trigger: 'blur' }
        ],
        vhcLongNameGao: [
          { required: true, message: '请输入高', trigger: 'blur' }
        ],
        vhcNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
          this.rule.vhcNo
        ],
        noColour: [
          { required: true, message: '请选择车牌颜色', trigger: ['blur', 'change'] }
        ],
        vhcCompany: [
          { required: true, message: '请输入所属单位', trigger: 'blur' }
        ],
        vhcCompany1: [
          { required: true, message: '请输入所属个人', trigger: 'blur' }
        ],
        vhcTypeName: [{ required: true, message: '请选择车辆类型', trigger: ['blur', 'change'] }],
        vhcClassify: [{ required: true, message: '请选择车辆所属', trigger: ['blur', 'change'] }],
        energyName: [{ required: true, message: '请选择能源类型', trigger: ['blur', 'change'] }],
        purposeName: [{ required: true, message: '请选择使用性质', trigger: ['blur', 'change'] }],
        standardsName: [{ required: true, message: '请选择排放标准', trigger: ['blur', 'change'] }],
        drivingLicense: [{ required: true, message: '请输入行驶证号', trigger: 'blur' }],
        vhcQuality: [{ required: true, message: '请输入总质量', trigger: 'blur' }],
        weight: [{ required: true, message: '请输入载重', trigger: 'blur' }],
        vhcVinNo: [{ required: true, message: '请输入车辆识别代号', trigger: 'blur' }],
        vhcEngineNo: [{ required: true, message: '请输入发动机号', trigger: 'blur' }],
        transportNo: [{ required: true, message: '请输入道路运输证号', trigger: 'blur' }],
        issueAuthority: [{ required: true, message: '请输入发证机关', trigger: 'blur' }],
        issueDate: [{ required: true, message: '请选择发证日期', trigger: ['blur', 'change'] }],
        drivingExpiringDate: [{ required: true, message: '请选择行驶证有效期', trigger: ['blur', 'change'] }],
        registerDate: [{ required: true, message: '请选择注册日期', trigger: ['blur', 'change'] }],
        businessLicenseNo: [{ required: true, message: '请输道路运输经营许可证号', trigger: ['blur'] }],
        vehicleTenant: [{ required: true, message: '请选择所属单位/个人', trigger: ['blur'] }],
        brandModel: [{ required: true, message: '请输入品牌型号', trigger: ['blur'] }],
        trailerNo: [{ required: true, message: '请输入挂车牌号', trigger: 'blur' }],
        transportDateTo: [{ required: true, message: '请选择运输证有效期', trigger: 'blur' }],
        vehicleTenantName: [{ required: true, message: '请输入车辆所有人', trigger: 'blur' }],
        suoshuOrgId: [
          { required: true, message: '请选择所属队组', trigger: 'blur' }
        ],
        residualRate: [
          { required: true, message: '请输入残值率', trigger: 'blur' }
        ],
        residualType: [
          { required: true, message: '请选择残值类型', trigger: ['blur', 'change'] }
        ],
        residualAmount: [
          { required: true, message: '请输入残值金额', trigger: 'blur' }
        ],
        depreciationStartDate: [
          { required: true, message: '请选择折旧开始日期', trigger: 'blur' }
        ],
        depreciationEndDate: [
          { required: true, message: '请选择折旧结束日期', trigger: 'blur' }
        ],
        purchasePrice: [
          { required: true, message: '请输入购车款', trigger: 'blur' }
        ],
        blacklistReason: [
          { required: true, message: '请输入拉黑原因', trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      lookImgVisible: false,
      loading: 'false',
      vehicleSS: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '单位'
        },
        {
          value: 2,
          label: '个人'
        }
      ],
      NYtype: [],
      cllx: [
        { value: '', label: '请选择' },
        { value: 1, label: '集港' },
        { value: 2, label: '外发' }
      ],
      clys: [],
      ssdw: [], // 所属单位列表
      img: [],
      img1: [],
      img2: [],
      img3: [],
      img4: [],
      imgList: [],
      newImgFlag: false,
      imgfile: new FormData(),
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e7
        }
      },
      pickerOptionsB: {
        disabledDate (time) {
          return time.getTime() < new Date().setDate(new Date().getDate() - 1)
        }
      },
      btnFlg: [],
      btnIdArr: ['00IM0B0100', '00IM0B0200', '00IM0B0300',
        '00IM0B0400', '00IM0B0500', '00IM0B0600', '00IM0B0700', '00IM0B0800', '00IM0B0900', '00IM0B0A00'],
      trailerNoIsShow: false,
      zhuhuCode: localStorage.getItem('tenantCode'),
      zuzhiquanming: '',
      BMlist: [],
      gcList: [],
      dbMark: false,
      dbFrom: {},
      delBxIds: [],
      ocrVhc: '',
      bjData: {},
      isDisable: false,
      LHMark: false,
      LHFrom: {}
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/vehicleTow')
    // this.getList(this.searchFrom)
    cVTlist({}).then(res => {
      this.vehicleT = res
      // this.vehicleT.unshift({ id: '', name: '请选择' })
    })
    cVPlist({}).then(res => {
      this.clyt = res
      this.clyt.unshift({ id: '', name: '请选择' })
    })
    cVElist({}).then(res => {
      this.pfbz = res
      this.pfbz.unshift({ id: '', name: '请选择' })
    })
    cVhcEnergyTypeList({}).then(res => {
      this.NYtype = res
      this.NYtype.unshift({ id: '', energyName: '请选择' })
    })
    cVhcNoColourList({}).then(res => {
      this.clys = res
      this.clys.unshift({ id: '', colourName: '请选择' })
    })
    if (this.$route.params.key) {
      this.$set(this.searchFrom, 'vhcNo', this.$route.params.key)
    }
    this.getTree(true)
    tOverdueSetList().then(res => {
      if (res.length > 0) {
        this.bjData = res[0]
      }
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 165) + 'px'
    setInterval(function () {
      document.querySelectorAll('.el-cascader-node__label').forEach(el => {
        el.onclick = function () {
          if (this.previousElementSibling) this.previousElementSibling.click()
        }
      })
    }, 1000)
  },
  methods: {
    async exportFn (val) {
      this.isDisable = true
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      form.header = val
      await exportExcel(
        this.global.driverNameT + '/cVehicleInfo/exportVehicleInfoGcs',
        form,
        '挂车列表'
      )
      this.isDisable = false
    },
    // 超时报警颜色设置
    getCellStyle ({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'drivingExpiringDate' && row.drivingDays < this.bjData.drivingDays) {
        return { background: '#FEB0A4' }
      }
      if (column.property == 'transportDateTo' && row.transportDays < this.bjData.transportDays) {
        return { background: '#FEB0A4' }
      }
    },
    diaoboFn (row) {
      this.dbFrom = {
        suoshuOrgId: row.suoshuOrgId,
        id: row.id
      }

      // this.orgTreeData.forEach(item => {
      //   if (item.tenantCode == this.currentData.tenantCode) {
      //     let json = JSON.parse(JSON.stringify(item))
      //     this.BMlist = this.sAttributeList([json])
      //   }
      // })
      let jsonARR = JSON.parse(JSON.stringify(this.orgTreeData))
      this.BMlist = this.sAttributeList(jsonARR)
      this.dbMark = true
    },
    dbSave () {
      this.$refs.dbFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          cVehicleInfoDiaobos(this.dbFrom).then(res => {
            loading.close()
            this.dbMark = false
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
            this.getTree()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 拉黑
    laheiFn (row) {
      this.LHMark = true
      this.LHFrom = {}
      this.$set(this.LHFrom, 'vehicleId', row.id)
    },
    LHSave () {
      this.$refs.LHFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          addBlackList(this.LHFrom).then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            loading.close()
            this.LHMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 解锁
    jiesuoFn (row) {
      this.$confirm('是否执行解锁操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        VdelBlackList({
          vehicleId: row.id
        }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 保险日期修改
    bdrqChange (e, index) {
      this.$set(this.addFrom.insuranceList[index], 'insuranceDateFrom', e[0])
      this.$set(this.addFrom.insuranceList[index], 'insuranceDateTo', e[1])
    },
    // 添加保险
    addGoodFn (row) {
      let json = { ...row }
      delete json.id
      this.addFrom.insuranceList.push(json)
    },
    // 删除保险
    delGoodFn (index) {
      // if (this.addFrom.insuranceList.length == 1) {
      //   this.$alert('最后一条数据不能删除', '系统提示')
      //   return
      // }
      if (this.addFrom.insuranceList[index].id) {
        this.delBxIds.push(this.addFrom.insuranceList[index].id)
      }
      this.addFrom.insuranceList.splice(index, 1)
    },
    zuzhiChange (e) {
      const cascaderInstance = this.$refs.zuzhicascader // 假设你的el - cascader组件有ref="cascader"
      const checkedNodes = cascaderInstance.getCheckedNodes()[0]
      console.log(checkedNodes)
      this.$set(this.dbFrom, 'suoshuOrgName', checkedNodes.data.name)
      this.$set(this.dbFrom, 'suoshuOrgId', checkedNodes.data.id)
      this.$set(this.dbFrom, 'suoshuOrgCode', checkedNodes.data.code)
      this.$set(this.dbFrom, 'suoshuOrgType', checkedNodes.data.orgType)
    },
    renderContent (h, { node, data, store }) {
      var n = '(' + data.trailerNum + ')'
      return (
        <span class="custom-tree-node">
          <span>{node.label + n}</span>
        </span>)
    },
    // 点击树
    handleNodeClick (data, node) {
      this.currentData = {
        tenantCode: data.tenantCode,
        orgId: data.id,
        code: data.code,
        name: data.name,
        orgType: data.orgType
      }
      if (this.currentData.orgType == 1) {
        this.$set(this.searchFrom, 'companyOrgId', this.currentData.orgId)
        this.$set(this.searchFrom, 'teamOrgId', null)
        this.$set(this.searchFrom, 'operationOrgId', null)
      }
      if (this.currentData.orgType == 2) {
        this.$set(this.searchFrom, 'companyOrgId', null)
        this.$set(this.searchFrom, 'teamOrgId', this.currentData.orgId)
        this.$set(this.searchFrom, 'operationOrgId', null)
      }
      if (this.currentData.orgType == 3) {
        this.$set(this.searchFrom, 'companyOrgId', null)
        this.$set(this.searchFrom, 'teamOrgId', null)
        this.$set(this.searchFrom, 'operationOrgId', this.currentData.orgId)
      }
      this.getList(this.searchFrom)
      // let parentNames = []
      // let currentNode = node
      // if (data.orgType == 3) {
      //   while (currentNode.parent) {
      //     if (currentNode.parent.data.name) {
      //       parentNames.unshift(currentNode.parent.data.name)
      //     }
      //     currentNode = currentNode.parent
      //   }
      //   parentNames.push(data.name)
      //   this.zuzhiquanming = parentNames.join('/')
      // }
    },
    // 获取左侧菜单
    getTree (flag) {
      organizationTree({ tenantCode: this.zhuhuCode }).then((res) => {
        this.orgTreeData = res
        if (this.orgTreeData.length != 0) {
          this.$nextTick(function () {
            // console.log(this.$refs.orgTree);
            if (this.$refs.orgTree) {
              this.$refs.orgTree.setCurrentKey(this.currentData.orgId)
              // console.log(this.currentData.orgId + "、、、");
              // this.tableList = this.$refs.orgTree.getNode(this.currentData.parentId).data.children
            }
          })
          if (flag) {
            this.currentData = {
              tenantCode: this.orgTreeData[0].tenantCode,
              orgId: this.orgTreeData[0].id,
              code: this.orgTreeData[0].code,
              name: this.orgTreeData[0].name,
              orgType: this.orgTreeData[0].orgType
            }
          }
          if (this.currentData.orgType == 1) {
            this.$set(this.searchFrom, 'companyOrgId', this.currentData.orgId)
            this.$set(this.searchFrom, 'teamOrgId', null)
            this.$set(this.searchFrom, 'operationOrgId', null)
          }
          if (this.currentData.orgType == 2) {
            this.$set(this.searchFrom, 'teamOrgId', this.currentData.orgId)
            this.$set(this.searchFrom, 'operationOrgId', null)
          }
          if (this.currentData.orgType == 3) {
            this.$set(this.searchFrom, 'operationOrgId', this.currentData.orgId)
          }
          this.getList(this.searchFrom)
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 车辆类型切换
    vhcTypeChange (e) {
    },
    // 图片上传
    handleRemove (data) {
      this.imgList[0] = null
    },
    isDate (str) {
      return /^\d{4}-\d{2}-\d{2}$/.test(str) || /^(\d{4})年(\d{2})月(\d{2})日$/.test(str)
    },
    imgPreview (data) { // 行驶证正
      this.imgList[0] = data[0]
      let imgfile = new FormData()
      compressImage(data[0].url, data[0].raw, {
        width: 600
      }).then(result => {
        imgfile.set('params', JSON.stringify({ side: 'front', type: 'vehicleLicense' }))
        imgfile.append('file', result)
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        ocrIdentification(imgfile).then(res => {
          loading.close()
          if (res) {
            this.ocrVhc = res.plateNumber
            if (!this.isAdd) { // 修改的时候
              if (this.addFrom.vhcNo == res.plateNumber) {
                this.$set(this.addFrom, 'brandModel', res.brandAndModel)
                this.$set(this.addFrom, 'registerDate', res.dateOfRegistration)

                if (this.isDate(res.dateOfIssue)) {
                  this.$set(this.addFrom, 'issueDate', res.dateOfIssue)
                }
                this.$set(this.addFrom, 'issueAuthority', res.fzdw)
                this.$set(this.addFrom, 'purposeName', res.natureOfUse)
                this.$set(this.addFrom, 'vhcTypeName', res.vehicleType)

                this.$set(this.addFrom, 'vhcVinNo', res.vehicleIdentificationNumber)
                this.$set(this.addFrom, 'vhcEngineNo', res.engineNumber)
                this.$set(this.addFrom, 'vehicleTenantName', res.all)
              } else {
                this.$alert('您上传的行驶证车牌号，与当前的车牌号不符，请核对行驶证照片后再上传。', '系统提示')
              }
            } else {
              if (this.isAdd) {
                this.$set(this.addFrom, 'vhcNo', res.plateNumber)
              }

              this.$set(this.addFrom, 'brandModel', res.brandAndModel)
              this.$set(this.addFrom, 'registerDate', res.dateOfRegistration)

              if (this.isDate(res.dateOfIssue)) {
                this.$set(this.addFrom, 'issueDate', res.dateOfIssue)
              }
              this.$set(this.addFrom, 'issueAuthority', res.fzdw)
              this.$set(this.addFrom, 'purposeName', res.natureOfUse)
              this.$set(this.addFrom, 'vhcTypeName', res.vehicleType)

              this.$set(this.addFrom, 'vhcVinNo', res.vehicleIdentificationNumber)
              this.$set(this.addFrom, 'vhcEngineNo', res.engineNumber)
              this.$set(this.addFrom, 'vehicleTenantName', res.all)
            }
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      })
    },
    handleRemove1 (data) {
      this.imgList[1] = null
    },
    async imgPreview1 (data) { // 行驶证副业
      this.imgList[1] = data[0]
      let imgfile = new FormData()
      let yasuo = ''
      await compressImage(data[0].url, data[0].raw, {
        width: 600
      }).then(result => {
        yasuo = result
      })
      imgfile.set('params', JSON.stringify({ side: 'back', type: 'vehicleLicense' }))
      imgfile.append('file', yasuo)
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      ocrIdentification(imgfile).then(res => {
        loading.close()
        console.log(res)
        if (res) {
          this.$set(this.addFrom, 'vhcQuality', res.totalMass)
          this.$set(this.addFrom, 'weight', res.approvedLoadCapacity)
          this.$set(this.addFrom, 'vhcLongNameChang', res.l)
          this.$set(this.addFrom, 'vhcLongNamekuan', res.w)
          this.$set(this.addFrom, 'vhcLongNameGao', res.h)
          this.$set(this.addFrom, 'energyName', res.fuelType)
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    handleRemove2 (data) {
      this.img2 = []
      this.imgList[2] = null
    },
    imgPreview2 (data) {
      this.img2 = [data[0]]
      this.imgList[2] = data[0]
    },
    handleRemove3 (data) {
      this.imgList[3] = null
    },
    async imgPreview3 (data) { // 道路运输证
      this.imgList[3] = data[0]
      let imgfile = new FormData()
      let yasuo = ''
      await compressImage(data[0].url, data[0].raw, {
        width: 600
      }).then(result => {
        yasuo = result
      })
      imgfile.set('params', JSON.stringify({ type: 'roadTransportCertificate' }))
      imgfile.append('file', yasuo)
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      ocrIdentification(imgfile).then(res => {
        loading.close()
        console.log(res)
        if (res) {
          this.$set(this.addFrom, 'businessLicenseNo', res.businessLicense)
          this.$set(this.addFrom, 'transportNo', res.roadTransportCertificateNumber)
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    handleRemove4 (data) {
      this.imgList[4] = null
    },
    imgPreview4 (data) {
      this.imgList[4] = data[0]
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      this.searchFrom.trailerFlag = 1
      this.searchFrom.vhcClassify = 2
      cVIlists(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    vehicleSSAddChange (value) {

    },

    // 查看详情
    lookFn (row, n) {
      if (n == 1) {
        cVehicleInfoDetail({ id: row.trailerId }).then(res => {
          this.addFrom = JSON.parse(JSON.stringify(res))
          this.lookImgVisible = true
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      } else {
        cVehicleInfoDetail({ id: row.id }).then(res => {
          this.addFrom = JSON.parse(JSON.stringify(res))

          this.lookImgVisible = true
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      }
    },
    // 获取车辆信息
    CPHfn () {
      if (this.isAdd) {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        this.newImgFlag = false
        getCVehicleInfo({ vhcNo: this.addFrom.vhcNo }).then(res => {
          loading.close()
          if (this.addFrom.id) { // 清空页面
            let vhcNo = this.addFrom.vhcNo
            this.addFrom = {
              vhcNo: vhcNo,
              vhcClassify1: []

            }
            this.vhcType = {}
            this.vhcL = {}
            this.img = []
            this.img1 = []
            this.img2 = []
            this.img3 = []
            this.img4 = []
            this.newImgFlag = true
          } else {
            this.newImgFlag = true
          }
          if (res.id) {
            this.fuzhi(res)
            this.newImgFlag = true
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    // 添加
    addVeicle () {
      this.title = '添加'
      this.dialogVisible = true
      this.isAdd = true
      this.newImgFlag = true
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
      this.addFrom = {
        trailerFlag: 1,
        insuranceList: []
      }
      this.img = []
      this.img1 = []
      this.img2 = []
      this.img3 = []
      this.img4 = []
      if (this.currentData.orgType == 3) {
        cVIlists({ operationOrgId: this.currentData.orgId }).then(res => {
          this.gcList = res
        })
      }
      this.ocrVhc = ''
    },
    // 车辆赋值
    fuzhi (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      if (row.noColourId) {
        this.$set(this.addFrom, 'noColour', { id: row.noColourId, name: row.noColourName })
      }

      if (row.vhcLongName) {
        let long = this.addFrom.vhcLongName.split('*')
        // console.log(long);
        this.$set(this.addFrom, 'vhcLongNameChang', long[0])
        this.$set(this.addFrom, 'vhcLongNamekuan', long[1])
        this.$set(this.addFrom, 'vhcLongNameGao', long[2])
      }
      if (row.vhcLicense1Url) {
        this.$set(this.img, 0, { status: 'ready', url: row.vhcLicense1Url })
        this.$set(this.imgList, 0, 1)
      }
      if (row.vhcLicense2Url) {
        this.$set(this.img1, 0, { status: 'ready', url: row.vhcLicense2Url })
        this.$set(this.imgList, 1, 1)
      }
      if (row.vhcLicense3Url) { // 年检页
        this.$set(this.img2, 0, { status: 'ready', url: row.vhcLicense3Url })
        this.$set(this.imgList, 2, 1)
      }
      if (row.transportPhotoUrl) {
        this.$set(this.img3, 0, { status: 'ready', url: row.transportPhotoUrl })
        this.$set(this.imgList, 3, 1)
      }
      if (row.environmentalProtectionFileUrl) { // 环保清单
        this.$set(this.img4, 0, { status: 'ready', url: row.environmentalProtectionFileUrl })
        this.$set(this.imgList, 4, 1)
      }
      this.$set(this.addFrom, 'issueDate', dateFormat1(row.issueDate))
      this.$set(this.addFrom, 'drivingExpiringDate', dateFormat1(row.drivingExpiringDate))
      this.$set(this.addFrom, 'registerDate', dateFormat1(row.registerDate))
      this.$set(this.addFrom, 'transportDateTo', dateFormat1(row.transportDateTo))
      this.$set(this.addFrom, 'rentalCosts', row.rentalCosts / 100)
      if (row.rentalDateFrom) {
        this.$set(this.addFrom, 'zlqzrq', [dateFormat1(row.rentalDateFrom), dateFormat1(row.rentalDateTo)])
      }
      cVehicleInfoDetail({ id: row.id }).then(res => {
        let arrbx = []
        // res.cVehicleInsuranceList.forEach(item => {
        //   this.$set(item, 'insuranceDate', [dateFormat1(item.insuranceDateFrom), dateFormat1(item.insuranceDateTo)])
        //   this.$set(item, 'insuranceCosts', item.insuranceCosts / 100)
        //   this.$set(item, 'maximumAmount', item.maximumAmount / 100)
        //   arrbx.push(item)
        // })
        if (arrbx.length == 0) {
          this.$set(this.addFrom, 'insuranceList', [])
        } else {
          this.$set(this.addFrom, 'insuranceList', arrbx)
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 递归判断列表，把最后的children设为undefined
    sAttributeList (data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.sAttributeList(data[i].children)
        }
      }
      return data
    },
    residualChange (e) {
      if (e === 1) {
        this.$set(this.addFrom, 'residualAmount', '')
      } else {
        this.$set(this.addFrom, 'residualRate', '')
      }
    },
    // 修改
    modifyVeicle (row) {
      this.addFrom = {
        vhcClassify1: [],
        vhcPhoto1: '',
        vhcPhoto2: '',
        guaKaoUrl: ''
      }
      this.vhcType = {}
      this.vhcL = {}
      if (this.$refs.table) {
        this.$refs.table.clearSelection()
      }
      this.orgTreeData.forEach(item => {
        if (item.tenantCode == this.currentData.tenantCode) {
          let json = JSON.parse(JSON.stringify(item))
          this.BMlist = this.sAttributeList([json])
        }
      })
      this.img = []
      this.img1 = []
      this.img2 = []
      this.img3 = []
      this.img4 = []
      this.imgfile = null
      this.imgfile = new FormData()
      this.newImgFlag = false
      this.fuzhi(row)
      this.newImgFlag = true
      this.title = '修改'
      this.dialogVisible = true
      this.isAdd = false
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
      if (row.residualType) {
        this.$set(this.addFrom, 'residualType', row.residualType.toString())
      }
      // if (row.operationOrgId) {
      //   cVIlists({ operationOrgId: row.operationOrgId }).then(res => {
      //     this.gcList = res
      //   })
      // }
      this.ocrVhc = ''
    },
    getVhcQualityFlag (str) {
      let index = str.toString().indexOf('.') + 1
      let before = str.toString().substring(0, index - 1)
      // let after = str.substring(index)
      if (before.length > 2) {
        this.$alert('重量小数点前保留2位', '系统提示')
        return false
      }
      return true
    },
    getWaikuoFlag (str) {
      let index = str.toString().indexOf('.') + 1
      let before = str.toString().substring(0, index - 1)
      // let after = str.substring(index)
      if (before.length > 2) {
        this.$alert('外廓尺寸小数点前保留2位', '系统提示')
        return false
      }
      return true
    },
    saveFn (formName) {
      this.imgfile = null
      this.imgfile = new FormData()
      // if (this.ocrVhc && this.ocrVhc != this.addFrom.vhcNo && !this.isAdd) {
      //   this.$alert('您上传的行驶证车牌号，与当前的车牌号不符，请核对行驶证照片后再提交。', '系统提示')
      //   return
      // }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addFrom.vhcClassify = 2
          // debuggercon
          if ((this.addFrom.weight < 0) && (this.addFrom.vhcQuality < this.addFrom.weight)) {
            this.$alert('总质量应该大于载重且载重不能为0', '系统提示')
          } else {
            if (this.addFrom.vhcQuality) {
              if (!this.getVhcQualityFlag(this.addFrom.vhcQuality)) { return }
            }
            if (this.addFrom.weight) {
              if (!this.getVhcQualityFlag(this.addFrom.weight)) { return }
            }
            if (this.addFrom.vhcLongNameChang) {
              if (!this.getWaikuoFlag(this.addFrom.vhcLongNameChang)) { return }
            }
            if (this.addFrom.vhcLongNamekuan) {
              if (!this.getWaikuoFlag(this.addFrom.vhcLongNamekuan)) { return }
            }
            if (this.addFrom.vhcLongNameGao) {
              if (!this.getWaikuoFlag(this.addFrom.vhcLongNameGao)) { return }
            }
            if (Number(this.addFrom.vhcLongNameChang) > 99 || Number(this.addFrom.vhcLongNamekuan) > 99 || Number(this.addFrom.vhcLongNameGao) > 99) {
              this.$alert('外廓尺寸整数位不能大于2位', '系统提示')
              return
            }
            if (Number(this.addFrom.vhcQuality) > 99) {
              this.$alert('重量整数位不能大于2位', '系统提示')
              return
            }
            if (Number(this.addFrom.weight) > 41) {
              this.$alert('载重不能大于41吨', '系统提示')
              return
            }
            this.addFrom.deleteInsuranceIds = this.delBxIds.toString()
            this.addFrom.noColourName = this.addFrom.noColour.colourName
            this.addFrom.noColourId = this.addFrom.noColour.id
            this.addFrom.noColourCode = this.addFrom.noColour.colourCode

            let json = this.vehicleT.filter(item => item.name == this.addFrom.vhcTypeName)
            if (json.length > 0) {
              this.addFrom.vhcTypeId = json[0].id
              this.addFrom.vhcTypeCode = json[0].code
            } else {
              this.$set(this.addFrom, 'vhcTypeName', null)
              this.$alert('请选择车辆类型', '系统提示')
              return
            }

            let json1 = this.NYtype.filter(item => item.energyName == this.addFrom.energyName)
            if (json1.length > 0) {
              this.addFrom.energyId = json1[0].id
              this.addFrom.energyCode = json1[0].energyCode
            } else {
              this.$set(this.addFrom, 'energyName', null)
            }

            let json2 = this.clyt.filter(item => item.name == this.addFrom.purposeName)
            if (json2.length > 0) {
              this.addFrom.purposeId = json2[0].id
            } else {
              this.addFrom.purposeId = -1
            }

            let json3 = this.pfbz.filter(item => item.name == this.addFrom.standardsName)
            if (json3.length > 0) {
              this.addFrom.standardsId = json3[0].id
            } else {
              this.$set(this.addFrom, 'standardsName', null)
            }

            let json4 = this.gcList.filter(itme => itme.vhcNo == this.addFrom.trailerNo)
            if (json4.length > 0) {
              this.addFrom.trailerId = json4[0].id
            } else {
              this.$set(this.addFrom, 'trailerNo', null)
              this.$set(this.addFrom, 'trailerId', null)
            }
            let chang = this.addFrom.vhcLongNameChang ? this.addFrom.vhcLongNameChang : ''
            let kuan = this.addFrom.vhcLongNamekuan ? this.addFrom.vhcLongNamekuan : ''
            let gao = this.addFrom.vhcLongNameGao ? this.addFrom.vhcLongNameGao : ''
            this.addFrom.vhcLongName = chang + '*' + kuan + '*' + gao
            if (this.addFrom.zlqzrq) {
              this.$set(this.addFrom, 'rentalDateFrom', this.addFrom.zlqzrq[0])
              this.$set(this.addFrom, 'rentalDateTo', this.addFrom.zlqzrq[1])
            }
            if (this.addFrom.trailerFlag == 1) { // 是挂车的时候
              this.$set(this.addFrom, 'energyId', null)
              this.$set(this.addFrom, 'energyName', null)
              this.$set(this.addFrom, 'vhcEngineNo', null)
              this.$set(this.addFrom, 'standardsName', null)
              this.$set(this.addFrom, 'standardsId', null)
              if (this.imgList.length == 5) {
                this.imgList.pop()
              }
            }
            if (this.isAdd) { // 新增需要的逻辑
              if (this.currentData.orgType == 1) {
                this.addFrom.companyOrgName = this.currentData.name
                this.addFrom.companyOrgCode = this.currentData.code
                this.addFrom.companyOrgId = this.currentData.orgId
              }
              if (this.currentData.orgType == 2) {
                this.addFrom.teamOrgName = this.currentData.name
                this.addFrom.teamOrgCode = this.currentData.code
                this.addFrom.teamOrgId = this.currentData.orgId
              }
              if (this.currentData.orgType == 3) {
                this.addFrom.operationOrgName = this.currentData.name
                this.addFrom.operationOrgCode = this.currentData.code
                this.addFrom.operationOrgId = this.currentData.orgId
              }
              this.addFrom.suoshuOrgType = this.currentData.orgType
              this.addFrom.suoshuOrgId = this.currentData.orgId
              this.addFrom.suoshuOrgCode = this.currentData.code
              this.addFrom.suoshuOrgName = this.currentData.name
            } else {
            }
            if (this.img2.length == 0) {
              this.imgList[2] = null
              this.addFrom.vhcLicense3 = ' '
            }
            this.imgfile.set('params', JSON.stringify(this.addFrom))
            if ((this.addFrom.trailerFlag == 1 && this.imgList.length != 4) || (this.addFrom.trailerFlag == '0' && this.imgList.length != 5)) {
              this.$alert('请上传证件信息', '系统提示')
              return
            }
            let arr = []
            for (let i = 0; i < this.imgList.length; i++) {
              if (this.imgList[i]) {
                if (this.imgList[i] != 1) {
                  arr.push({ img: this.imgList[i], index: i })
                }
              } else {
                if (i != 2) { // 年检页不必填
                  this.$alert('请上传证件信息', '系统提示')
                  return
                }
              }
            }
            if (arr.length > 0) {
              for (let i = 0; i < arr.length; i++) {
                let a = i
                compressImage(arr[i].img.url, arr[i].img.raw, {
                  width: 1000
                }).then(result => {
                  this.imgfile.append('file' + arr[a].index, result)// result即为压缩后的结果
                  if (a == arr.length - 1) {
                    this.save1()
                  }
                })
              }
            } else {
              this.save1()
            }
          }
        } else {
          return false
        }
      })
    },
    save1 () {
      var that = this
      if (this.isAdd) {
        const loading = that.$loading({
          lock: true,
          text: '正在处理...'
        })
        cVIadds(that.imgfile).then(res => {
          loading.close()
          that.$message({
            message: '添加成功',
            type: 'success'
          })
          that.dialogVisible = false
          that.getList(that.searchFrom)
          this.getTree()
        }).catch(error => {
          that.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      } else {
        const loading = that.$loading({
          lock: true,
          text: '正在处理...'
        })
        cVIupdates(that.imgfile).then(res => {
          loading.close()
          that.$message({
            message: '修改成功',
            type: 'success'
          })
          that.dialogVisible = false
          that.getList(that.searchFrom)
          this.getTree()
        }).catch(error => {
          that.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    // 删除
    delVeicle () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据')
      } else {
        var that = this
        this.ids = []
        selectData.some(item => {
          that.ids.push(item.id)
        })
        this.$confirm('是否执行删除操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          cVIdeletes({ ids: this.ids }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
            this.getTree()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      }
    },
    closeDialog (formName) {
      this.$refs[formName].resetFields()
      this.addFrom = {}
      this.imgList = []
    },
    closeDialogB () {

    },
    closeDialogC () {},
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null,
        registerDate: null
      }
      if (this.currentData.orgType == 1) {
        this.$set(this.searchFrom, 'companyOrgId', this.currentData.orgId)
        this.$set(this.searchFrom, 'teamOrgId', null)
        this.$set(this.searchFrom, 'operationOrgId', null)
      }
      if (this.currentData.orgType == 2) {
        this.$set(this.searchFrom, 'companyOrgId', null)
        this.$set(this.searchFrom, 'teamOrgId', this.currentData.orgId)
        this.$set(this.searchFrom, 'operationOrgId', null)
      }
      if (this.currentData.orgType == 3) {
        this.$set(this.searchFrom, 'companyOrgId', null)
        this.$set(this.searchFrom, 'teamOrgId', null)
        this.$set(this.searchFrom, 'operationOrgId', this.currentData.orgId)
      }
      this.searchFn()
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
.jiaoyan /deep/.el-date-editor {
    width: 150px!important;
}
/deep/.jiaoyan .el-date-editor .el-input__inner {
    width: 150px;
}
.box{
  .imgBox{
    display: flex;
      margin-right:20px;
    flex-direction: column;
    width: 240px;
    /deep/.el-upload--picture-card,/deep/.el-upload-dragger{
      width: 240px;
      height: 120px;
      background-color:transparent;
      background-image: url(../../../../assets/images/upload1.png);
      background-size: 100%;
      background-position: 50% 50%;
    }
  }
  h6{
    text-align: center;
    margin: 15px;
    margin-top: -23px;
    font-size: 12px;
  }
  .hidden /deep/.el-upload--picture-card{
  display: none;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item{
    width: 240px;
    height: 116px;
    margin: 0;
  }
}
.loogImgBox{
  display: flex;
  justify-content: space-around;
  .box1{
    width: 48%;
  }
  img{
    width: 100%;
  }
}

  /deep/.inpBox .bigInp .el-input__inner{
width: 250px;
}
.detailBox .el-form-item span{
  display:inline-block;
  width: 150px;
}
.detailBox img{
   width: 320px;
    height: 200px;
}
.detailBox /deep/ .el-date-editor--date .el-input__inner{
  border: none;
  font-size: 14px;

}
/deep/.image-slot{
    height: 100%;
    background: #f3f1f1;
    font-size: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.waikuo{
  display: flex;
  flex-direction: row;
}
.treeBigBox{
  display:flex;
  font-size: 14px;
}
.treeBox{
   width: 100%;
  text-align: center;
  padding:0;
  height: calc(100vh - 156px);
  overflow: auto;
}
.title{
  width: 100%;
  height: 36px;
  background: #D8E3F8;
  display: flex;
  align-items: center;
  padding-left: 20px;
  box-sizing: border-box;
  font-size: 14px;
  .xian{
    width: 4px;
    height: 16px;
    border-radius: 2px;
    background-color: rgba(11, 79, 214, 100);
    margin-right: 4px;
  }
}
.right{
  // flex: 1;
  // width: 75%;
  width: calc(100% - 260px);
}
.boxLeft{
  // width:30%;
  width:260px;
  border-right: 1px dashed #ddd;
  box-sizing: border-box;
}
/deep/.el-tree-node__content{
  white-space: nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
.borderBox .el-form-item--mini.el-form-item{
      margin-bottom: 22px !important;
}
.borderBox{
  border:1px solid #ccc;
  padding: 20px 10px;
  border-radius: 10px;
}
.jiaoyan .inpBoxA /deep/.el-date-editor .el-input__inner{
  width: 150px;
}
.jiaoyan .inpBoxA /deep/.el-form-item__content{
 width: 150px;
}
.wkccBox /deep/.el-form-item__content{
 width: 320px!important;
}
.zlBox /deep/.el-form-item__content{
  width: 80px!important;
}
.detailBox{
  .imgBox{
    height: 132px;
  }

}
.jiaoyan .el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
.jiaoyan /deep/ .el-date-editor{
      width: 267px !important
}
/deep/.el-tree{
  height: 100%;
}
/* 修复残值类型单选框换行问题 */
.jiaoyan .borderBox .el-form-item .el-radio-group {
  white-space: nowrap;
  display: inline-block;
  width: auto;
}
/* 如果还不行，强制设置该表单项内部不换行 */
.jiaoyan .borderBox .el-form-item[prop="fiveInsurances"] .el-form-item__content {
  white-space: nowrap;
  line-height: 32px; /* 与输入框高度对齐 */
}

/* 确保 radio 选项在同一行 */
.jiaoyan .borderBox .el-radio {
  margin-right: 15px;
  display: inline-flex;
  align-items: center;
}
</style>
